// src/store/useAuthStore.ts
import { create } from "zustand";

interface AuthStore {
  supportCount: boolean;
  setSupportCount: (supportCount: boolean) => void;
}

export const useAuthStore = create<AuthStore>((set) => ({
  supportCount: false,
  setSupportCount: (supportCount) => {
    set({ supportCount });
  },

 
}));
